module.exports = __webpack_public_path__ + "static/media/landingBg.6da0cf53.jpg";